// extracted by mini-css-extract-plugin
export default {"container":"EAAFooterPage_container__8PygF"};